import { createAsyncThunk } from '@reduxjs/toolkit';
import { instanceApi } from 'libs';
import { authService } from 'services';
import { LoginError, LoginRequest, LoginResponse, ThunkAPI, LoginWithTokenRequest } from 'types';
import { userRole } from '../../constant';

export const signIn = createAsyncThunk<LoginResponse, LoginRequest, ThunkAPI<LoginError>>(
  'login/thunk/signIn',
  async (dataLogin, { rejectWithValue }) => {
    try {
      const { data } = await authService.login(dataLogin);
      if (data.role && data.role !== userRole.WORKER) {
        await instanceApi.interceptors.request.use(
          async (config) => {
            config.headers = await {
              Authorization: `Bearer ${data?.access_token}`,
            };
            return config;
          },
          (error) => {
            Promise.reject(error);
          }
        );
        localStorage.setItem('access_token', `${data?.access_token}`);
        localStorage.setItem('refresh_token', `${data?.refresh_token}`);
        localStorage.setItem('role', `${data?.role}`);
        localStorage.setItem('user_name', `${data?.user_name}`);
        localStorage.setItem('cooperator_id', `${data?.cooperator_id}`);
        localStorage.setItem('user_id', `${data?.user_id}`);
        localStorage.setItem('kengen_code', `${data?.kengen_code}`);
        // 2023/11/7 Leading Win ログイン変更対応 start
        localStorage.setItem('business_owner_flg', `${data?.business_owner_flg}`);
        localStorage.setItem('syokucyou_flg', `${data?.syokucyou_flg}`);
        // 2023/11/7 Leading Win ログイン変更対応 end
        return data;
      } else {
        return rejectWithValue({
          response: {
            data: {
              message: 'このユーザはPCからログインできません。アプリからログインしてください。',
            },
          },
        });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const signInWithToken = createAsyncThunk<
  LoginResponse,
  LoginWithTokenRequest,
  ThunkAPI<LoginError>
>('login/thunk/signInWithToke', async (dataLogin, { rejectWithValue }) => {
  try {
    const { data } = await authService.verifyToken(dataLogin);
    if (data.role && data.role !== userRole.WORKER) {
      await instanceApi.interceptors.request.use(
        async (config) => {
          config.headers = await {
            Authorization: `Bearer ${data?.access_token}`,
          };
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      localStorage.setItem('access_token', `${data?.access_token}`);
      localStorage.setItem('refresh_token', `${data?.refresh_token}`);
      localStorage.setItem('role', `${data?.role}`);
      localStorage.setItem('user_name', `${data?.user_name}`);
      localStorage.setItem('cooperator_id', `${data?.cooperator_id}`);
      // 2023/11/7 Leading Win ログイン変更対応 start
      localStorage.setItem('business_owner_flg', `${data?.business_owner_flg}`);
      localStorage.setItem('syokucyou_flg', `${data?.syokucyou_flg}`);
      // 2023/11/7 Leading Win ログイン変更対応 end
      return data;
    } else {
      return rejectWithValue({
        response: {
          data: {
            message: 'このユーザはPCからログインできません。アプリからログインしてください。',
          },
        },
      });
    }
  } catch (error) {
    return rejectWithValue(error);
  }
});
